var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgHappyOutline = function SvgHappyOutline(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 35.5,
    cy: 33,
    rx: 6.5,
    ry: 9
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "currentColor",
    fillRule: "nonzero",
    cx: 59.5,
    cy: 33,
    rx: 6.5,
    ry: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,49 C75,63.9116883 62.6878306,76 47.5,76 C32.3121694,76 20,63.9116883 20,49",
    stroke: "currentColor",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,94 C72.95716,94 94,72.95716 94,47 C94,21.042605 72.95716,0 47,0 C21.042605,0 0,21.042605 0,47 C0,72.95716 21.042605,94 47,94 Z",
    stroke: "currentColor",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgHappyOutline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "happy-outline.d122c36a45259bc8f991d46f68c2b1a2.svg";